import { Button } from "@/components/shared/ui/button";
import useCalStore from "@/store/useCalStore";
import { Service } from "@/types/servicesTypes";
import Link from "next/link";
import Image from "next/image";

const SingleService = ({ service }: {
    service: Service
}) => {
    const { handleScheduleClick } = useCalStore()

    return (
        <div className="flex flex-col-reverse md:flex-row gap-6 md:gap-12 w-full">
            {/* Content Section */}
            <div className="flex flex-col gap-6 md:gap-12 w-full">
                <div>
                    <h3 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-wide text-title_color mb-4 md:mb-6">
                        {service.title}
                    </h3>

                    <p className="text-lg md:text-xl lg:text-2xl font-medium text-sub_text_color">
                        {service.subTitle}
                    </p>
                </div>

                <div className="space-y-8">
                    <div className="flex flex-col gap-4">
                        {service.features?.map((fea, index) => (
                            <div 
                                key={index} 
                                className="flex gap-3 md:gap-4 items-center bg-white rounded-xl p-3 md:p-4
                                         transition-all duration-300 shadow-soft hover:shadow-elevation"
                            >
                                <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12">
                                    <Image 
                                        src="/tik.svg" 
                                        alt="tick" 
                                        width={48}
                                        height={48}
                                        className="w-full h-full object-contain"
                                        priority
                                    />
                                </div>
                                <p className="text-base md:text-lg lg:text-xl font-medium text-title_color">
                                    {fea.desc}
                                </p>
                            </div>
                        ))}
                    </div>

                    <Button 
                        onClick={() => handleScheduleClick()} 
                        variant="secondary" 
                        className="w-full md:w-auto rounded-full py-6 md:py-7 px-8 md:px-10 
                                 text-lg md:text-xl font-semibold
                                 hover:scale-105 transition-all duration-300 
                                 bg-gradient-to-r from-primary to-secondary text-white
                                 shadow-lg hover:shadow-xl"
                    >
                        {service.action}
                    </Button>
                </div>
            </div>

            {/* Image Section */}
            <div className="w-[85%] md:w-1/2 mx-auto md:mx-0 mb-4 md:mb-0">
                <div className="relative aspect-[16/10]">
                    <Image 
                        src={service.img}
                        alt={service.title}
                        width={500}
                        height={312}
                        className="w-full h-full object-contain rounded-2xl shadow-soft hover:shadow-elevation 
                                 transition-all duration-300 hover:scale-[1.02]"
                        priority
                    />
                </div>
            </div>
        </div>
    )
}

export default SingleService
